import QueryString from "query-string";
import { history } from "../../../redux/configureStore";
import { getState } from "../../../app/StoreFactory";
import { merge } from "../../../lib/utils";
import { getIsRedesign } from "pages/redesign/preferences/redesignUtils";

export const getQueryString = () => QueryString.parse(window.location.search);

export const getParam = (key, qs = getQueryString()) => qs[key];

export const addParam = (key, value, qs = getQueryString(), isAddMode = true) => {
  if (isAddMode && qs[key]) {
    if (qs[key].includes(value)) return qs; // if duplicate do nothing
    qs[key] = toArray(qs[key]).concat(value);
  } else {
    qs[key] = [value];
  }
  return qs;
};

export const setParam = (key, value, qs) => addParam(key, value, qs, false);

export const removeParam = (key, value, qs = getQueryString()) => {
  if (value && Array.isArray(qs[key])) {
    qs[key] = qs[key].filter((i) => i !== value);
  } else {
    delete qs[key];
  }
  return qs;
};

// receives sort: {coveredBy.en: "analystName"}, pushes this as query param
export const setSort = (sort, qs = getQueryString()) => {
  delete qs.SortAsc;
  delete qs.SortDesc;
  let [key, value] = Object.entries(sort)[0];
  qs[key] = value;
  push(qs);
};

export function gotoSearchResultsPage(key, value, page = "/Search_Results") {
  let qs = isString(key) ? addParam(key, value) : getQueryString();
  const pathFilter = getState().filter.pathFilter;
  qs.From = [1];
  qs = merge(pathFilter, qs);
  window.scrollTo(0, 0);
  if (getIsRedesign()) page = "/Home"
  push(qs, page);
}

export function gotoSearchPage() {
  return gotoSearchResultsPage(null, null, "/Search");
}

// switches between an all-field search and a title only search: ?=xyz <-> ?title=xyz
export function switchTitleQueryString(isTitleOnly, typing, qs = getQueryString()) {
  const [to, from] = isTitleOnly ? ["title", ""] : ["", "title"];
  qs[to] = typing;
  delete qs[from];
  push(qs);
}

export function switchTitleQueryStringAdvanced(isTitleOnly, qs = getQueryString()) {
  const allSearch = ["", "exact", "atleast", "exclude"];
  const titleSearch = ["title", "titleExact", "titleAtleast", "titleExclude"];
  allSearch.forEach((v, k) => {
    const [to, from] = isTitleOnly ? [titleSearch[k], v] : [v, titleSearch[k]];
    qs[to] = qs[from];
    delete qs[from];
  });
  push(qs);
}

export const push = (query = getQueryString(), path = getState().filter.path) => {
  return history.push(path + (query ? "?" + QueryString.stringify(query) : ""));
};

const toArray = (v) => (Array.isArray(v) ? v : [v]);
const isString = (s) => typeof s === "string";
